//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { selectQuestion } from './utils'
import Doing from '../_query_components/doing'
import Done from './done'
import { APP_CITY_NAME } from '@/config'
export default {
    components: {
        Doing,
        Done,
    },
    data() {
        return {
            current_question: {},
            answered_questions: [],
            show_result: false,
            result: '',
            desc: '',
            city: APP_CITY_NAME
        }
    },
    created() {
        this.current_question = selectQuestion()
    },
    methods: {
        reset() {
            this.answered_questions = []
            this.current_question = selectQuestion()
            this.show_result = false
            this.result = ''
            this.desc = ''
        },
        selectQuestion(selected_answer) {
            this.answered_questions.push({
                question_content: this.current_question.content,
                content: selected_answer.content,
                origin_question: this.current_question,
                order: this.answered_questions.length + 1
            })
            this.$nextTick(() => {
                this.current_question = selectQuestion(selected_answer.tree)
                if (this.current_question.end) {
                    this.show_result = true
                    this.result = this.current_question.content
                    this.desc = this.current_question.desc
                }
            })
        },
        deleteQuestion(index) {
            this.current_question = this.answered_questions[index].origin_question
            this.answered_questions.splice(index)
        },
    },
}
